export default __webpack_public_path__ + "static/media/Honored Bracers of the Greensward.04f4105e.jpg";